interface LargeCircularProgressProps {
  currentDay: number;
  totalDays: number;
}

export function LargeCircularProgress({ currentDay, totalDays }: LargeCircularProgressProps) {
  // Calculate progress percentage and stroke offset
  const percentage = (currentDay / totalDays) * 100;
  const circumference = 282.7; // 2 * PI * radius (45)
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="relative w-48 h-48">
      <svg className="absolute inset-0" viewBox="0 0 100 100">
        {/* Background circle */}
        <circle
          className="stroke-current text-primary/10"
          cx="50"
          cy="50"
          fill="none"
          r="45"
          strokeWidth="8"
        />
        {/* Progress circle */}
        <circle
          className="stroke-current text-primary"
          cx="50"
          cy="50"
          fill="none"
          r="45"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          strokeWidth="8"
          style={{ transform: 'rotate(-90deg)', transformOrigin: '50% 50%' }}
        />
      </svg>
      {/* Center content */}
      <div className="flex flex-col items-center justify-center h-full">
        <span className="text-sm font-medium text-primary">Day</span>
        <span className="text-6xl font-extrabold text-white" style={{
          textShadow: '0 0 8px rgba(13, 242, 13, 0.4), 0 0 20px rgba(13, 242, 13, 0.3)'
        }}>
          {currentDay}
        </span>
        <span className="text-sm font-medium text-white/70">of {totalDays}</span>
      </div>
    </div>
  );
}
